import { useDeleteTasks as _useDeleteTasks } from '@griply/hooks';
import { useCallback } from 'react';
import { useUpdateGoalMutation } from 'shared/hooks/queries/use-update-goal-mutation';
import { useUpdateTasksMutation } from 'shared/hooks/queries/use-update-tasks-mutation';
import { useTrackEvents } from 'shared/hooks/use-track-events';
import {
  ActionEvents,
  taskTypeToTrackingTaskType,
} from 'shared/services/tracking';
import { Task } from 'shared/types/task';

import { useTasks } from './use-tasks';

export const useDeleteTasks = () => {
  const track = useTrackEvents();
  const { mutateAsync: updateTasksAsync } = useUpdateTasksMutation();
  const { mutate: updateGoal } = useUpdateGoalMutation();
  const allTasks = useTasks();

  const handleTaskDeleted = useCallback(
    (task: Task) => {
      track(ActionEvents.TaskDelete, {
        type: taskTypeToTrackingTaskType[task.type],
      });
    },
    [track],
  );

  return _useDeleteTasks({
    allTasks,
    updateTasksAsync,
    updateGoal,
    onTaskDeleted: handleTaskDeleted,
  });
};
